(async () => {
  const el = document.getElementById('location-town-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/town/index.vue'),
    },
  ]

  await clientRender({ components })
})()
